// extracted by mini-css-extract-plugin
export default {"root":"ContentEditable__root--1KMl7"};